var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inited),expression:"inited"}]},[_c('search')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }